import GuideOverlay from 'components/GuideOverlay';
import { observer } from 'mobx-react';
import { Button } from 'office-ui-fabric-react/lib/Button';
import { Link } from 'office-ui-fabric-react/lib/Link';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import RoundSelector from './RoundSelector';

const GuideLayer = styled.section`
  border: solid 1px ${(props) => props.theme.palette.themePrimary};
  background: rgba(91, 160, 209, 0.133);
  margin: 0.1em 0;
  padding: 0.5em 1em;
  text-align: center;

  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;

  button {
    margin: 0 1em;
    background: ${(props) => props.theme.palette.themePrimary};
    color: #fff;

    .ms-Icon {
      margin-right: 0.2em;
    }
  }
`;

const GuideUpgradeLayer = styled(GuideLayer)`
  border: solid 1px #498205;
  background: #a7b992;
  margin: 0.1em 0;
  padding: 0.5em 1em;
  text-align: center;

  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;

  button {
    background: #498205;
  }
`;

const Guides = ({ app, store, t, theme }) => {
  const config = store.saleConfig;

  return (
    <React.Fragment>
      {
        /* not complete offer form */
        store.ui.guideNext === 'saleEdit' && (
          <GuideOverlay theme={theme}>
            <span>
              <p>
                {t('Guide - define offer form')}
                <br />
                {t('Guide - missing mandatory offer form')}
              </p>
              <Link onClick={() => store.ui.editSale()}>
                <i className="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>{' '}
                {t('Guide action - Edit sale')}
              </Link>
            </span>
          </GuideOverlay>
        )
      }

      {
        /* not defined round */
        store.ui.guideNext === 'roundStart' && (
          <GuideOverlay theme={theme}>
            <span>
              {config.roundTypes.includes('simple_offer') ? (
                <Fragment>
                  <p>{t('Guide - start round')}</p>
                  <RoundSelector
                    theme={theme}
                    handleSelect={(round) => {
                      store.round.definition.type = round;
                      store.ui.startRound();
                    }}
                  />
                </Fragment>
              ) : null}
              {!config.hideSaleEditGuide && (
                <Fragment>
                  <p>{t('Guide - start round edit sale')}</p>
                  <Link onClick={() => store.ui.editSale()}>
                    {app.features.saleReadOnly && (
                      <React.Fragment>
                        <i
                          className="ms-Icon ms-Icon--View"
                          aria-hidden="true"
                        ></i>{' '}
                        {t('Guide action - Start round view')}
                      </React.Fragment>
                    )}
                    {!app.features.saleReadOnly && (
                      <React.Fragment>
                        <i
                          className="ms-Icon ms-Icon--Edit"
                          aria-hidden="true"
                        ></i>{' '}
                        {t('Guide action - Start round edit')}
                      </React.Fragment>
                    )}
                  </Link>
                </Fragment>
              )}
              {!config.roundTypes.includes('simple_offer') ? (
                <Fragment>
                  <p>{t('Guide - start round')}</p>
                  <Link onClick={() => store.ui.startRound()}>
                    <i
                      className="ms-Icon ms-Icon--CirclePlus"
                      aria-hidden="true"
                    ></i>{' '}
                    {t('Guide action - Start round')}
                  </Link>
                </Fragment>
              ) : null}
            </span>
          </GuideOverlay>
        )
      }

      {
        /* not defined round */
        store.ui.guideNext === 'roundOpen' && (
          <GuideOverlay theme={theme}>
            <span>
              <p>{t('Guide - open round')}</p>
              <Link
                onClick={() => {
                  store.ui.prompt.open({
                    title: (
                      <div style={{ textAlign: 'center' }}>
                        {t('Guide action - Open round')}
                      </div>
                    ),
                    action: () => store.round.open(),
                    content: 'openRound',
                  });
                }}
              >
                <i
                  className="ms-Icon ms-Icon--MSNVideos"
                  aria-hidden="true"
                ></i>{' '}
                {t('Guide action - Open round')}
              </Link>
              <p>{t('Guide - edit round')}</p>
              <Link onClick={() => store.ui.startRound()}>
                <i className="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>{' '}
                {t('Guide action - edit round')}
              </Link>
            </span>
          </GuideOverlay>
        )
      }

      {
        /* no invites yet */
        store.ui.guideNext === 'registration' && (
          <GuideOverlay theme={theme}>
            {!app.features.registrationReadOnly && (
              <span>
                <p>{t('Guide - invite users')}</p>
                <Link onClick={() => store.ui.registerUser()}>
                  <i
                    className="ms-Icon ms-Icon--PeopleAdd"
                    aria-hidden="true"
                  ></i>{' '}
                  {t('Guide action - Invite bidders')}
                </Link>
              </span>
            )}
            {app.features.registrationReadOnly &&
              app.features.bulkRegistrationCsv && (
                <span>
                  <p>{t('Guide - import users csv')}</p>
                  {app.features.bulkRegistrationCsv && (
                    <Link onClick={() => store.ui.bulkRegistrationCsv()}>
                      <i
                        className="ms-Icon ms-Icon--AddGroup"
                        aria-hidden="true"
                      ></i>{' '}
                      {t('Guide action - import users csv')}
                    </Link>
                  )}
                </span>
              )}
          </GuideOverlay>
        )
      }

      {
        /* upgrade current round to auction */
        store.ui.showUpgrade && (
          <GuideUpgradeLayer theme={theme}>
            {t('Guides - upgrade')}
            {config.saleCommands.includes('settings') && (
              <Button onClick={() => store.ui.showSaleWizard('increase')}>
                <i className="ms-Icon ms-Icon--Feedback" aria-hidden="true"></i>{' '}
                {t('Guides - start open process')}
              </Button>
            )}
          </GuideUpgradeLayer>
        )
      }

      {
        /* round closed, resolve */
        (store.ui.guideNext === 'saleWizard' ||
          store.ui.guideNext === 'saleSimpleWizard') &&
          store.cmdBar.saleWizardEnabled && (
            <GuideLayer theme={theme}>
              {store.ui.guideNext === 'saleSimpleWizard'
                ? t('Guides - offers present')
                : t('Guides - round closed')}
              <Button onClick={store.ui.openOverview}>
                <i
                  className="ms-Icon ms-Icon--GroupedList"
                  aria-hidden="true"
                ></i>{' '}
                {t('Guides - Show overview')}
              </Button>
              {config.saleCommands.includes('settings') && (
                <Button onClick={() => store.ui.showSaleWizard()}>
                  <i
                    className="ms-Icon ms-Icon--Feedback"
                    aria-hidden="true"
                  ></i>{' '}
                  {t('Guides - Manage the sale')}
                </Button>
              )}
            </GuideLayer>
          )
      }
    </React.Fragment>
  );
};

export default observer(Guides);



// WEBPACK FOOTER //
// ./src/app/containers/Sale/Guides/index.jsx